import { testDataCreator } from '@wix/answers-lib';
import { ControlRoomGeneralColumns, ControlRoomSortType } from './domain';
import { TimeFrameOptions } from '../../domain';
export var createControlRoomTableDto = testDataCreator(function () { return ({
    timeframe: TimeFrameOptions.LAST_9_HOURS,
    timeZone: 'UTC',
    columns: [ControlRoomGeneralColumns.NAME],
    sortType: ControlRoomSortType.ATTEMPT_OUTBOUND_TICKETS_ASC,
    pageSize: 100,
}); });
export var defaultStats = {
    resolvedTickets: 0,
    avgCallDuration: 0,
    totalCallDuration: 0,
    completedCalls: 0,
    completedChats: 0,
    attemptOutboundCalls: 0,
    totalCompletedCallDuration: 0,
    avgCompletedCallDuration: 0,
    totalCalls: 0,
    medianCallDuration: 0,
    medianCompletedCallDuration: 0,
    totalReplies: 0,
    totalTicketHandlingDuration: 0,
    avgTicketHandlingDuration: 0,
    medianTicketHandlingDuration: 0,
    completedHandlingTickets: 0,
    missedChatReservationsCounts: 0,
    declinedChatReservationsCounts: 0,
    missedEmailReservationsCounts: 0,
    declinedEmailReservationsCounts: 0,
};
export var createFakeAgentStats = function (agent) {
    return ({
        agent: agent,
        fullStats: {
            LAST_12_HOURS: defaultStats,
            LAST_1_HOUR: defaultStats,
            LAST_24_HOURS: defaultStats,
            LAST_3_HOURS: defaultStats,
            LAST_6_HOURS: defaultStats,
            LAST_9_HOURS: defaultStats
        }
    });
};
//# sourceMappingURL=builders.js.map